import { Route } from 'react-router-dom';

import { SettingsFlowAuditLogView } from '../flow/views/auditLog';

import { SettingsChatView } from './settingsChat.view';
import { SettingsChatEditFlowView } from './views/editFlow';
import { SettingsChatSetupView } from './views/setup';

export const settingsChatRoutes = (
  <Route path="chat">
    <Route path="" element={<SettingsChatView />} />
    <Route path=":chatWidgetId" element={<SettingsChatSetupView />} />
    <Route path="flow/:flowId" element={<SettingsChatEditFlowView />} />
    <Route
      path="flow/:flowId/history"
      element={<SettingsFlowAuditLogView channel="chat" />}
    />
  </Route>
);
